import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBookOpenCover,
  faBooks,
  faBullseyeArrow,
  faCaretRight,
  faCheck,
  faCircleCheck,
  faCircleInfo,
  faCircleNodes,
  faCircleXmark,
  faClockRotateLeft,
  faDash,
  faDown,
  faDownload,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFileCertificate,
  faGauge,
  faHyphen,
  faLayerGroup,
  faLayerPlus,
  faList,
  faLock,
  faLockA,
  faMedal,
  faObjectsColumn,
  faPersonRunning,
  faQuestionCircle,
  faRotate,
  faScreenUsers,
  faSitemap,
  faSpinner,
  faSwap,
  faTriangleExclamation,
  faUndo,
  faUp,
  faUserCheck,
  faUserHeadset,
  faUsers,
  faUserSecret,
} from "@fortawesome/pro-solid-svg-icons";

export const initSolidIcons = () => {
  library.add(
    faBookOpenCover,
    faBooks,
    faBullseyeArrow,
    faCaretRight,
    faCheck,
    faCircleCheck,
    faCircleInfo,
    faCircleNodes,
    faCircleXmark,
    faClockRotateLeft,
    faDash,
    faDown,
    faDownload,
    faExclamationTriangle,
    faEye,
    faEyeSlash,
    faFileCertificate,
    faGauge,
    faHyphen,
    faLayerGroup,
    faLayerPlus,
    faList,
    faLock,
    faLockA,
    faMedal,
    faObjectsColumn,
    faPersonRunning,
    faQuestionCircle,
    faRotate,
    faScreenUsers,
    faSitemap,
    faSpinner,
    faSwap,
    faTriangleExclamation,
    faUndo,
    faUp,
    faUserCheck,
    faUserHeadset,
    faUserSecret,
    faUsers,
  );
};
